import { render } from "./ProductosPrecioView.vue?vue&type=template&id=790a14ec&scoped=true"
import script from "./ProductosPrecioView.vue?vue&type=script&lang=js"
export * from "./ProductosPrecioView.vue?vue&type=script&lang=js"

import "./ProductosPrecioView.vue?vue&type=style&index=0&id=790a14ec&scoped=true&lang=css"
import "./ProductosPrecioView.vue?vue&type=style&index=1&id=790a14ec&scoped=true&lang=css"
import "./ProductosPrecioView.vue?vue&type=style&index=2&id=790a14ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790a14ec"]])

export default __exports__